<template>
  <div>
    <mrc_ess_table
      v-if="$route.name == 'jobs_manage'"
      :pageName="pageName"
      :headers="headers"
      :paginationOptions="options"
      @turnPage="getlist"
      :isLoading="loading"
      :hideAddBtn="!hasBtn('add-job-position')"
      :slotKey="['job_post_name', 'dept', 'is_used']"
      :items="desserts"
    >
      <template v-slot:btns>
        <!-- <v-btn small
               tag="a"
               depressed
               height="40"
               v-btnAuth="['download-job-position-template']"
               :href="uploadUrl"
               rounded
               class="ml-4 white--text text-button"
               color="primary">
          {{ $t('label_Download_the_template') }}
        </v-btn> -->
        <mrc_ess_uploadBtn
          type="4"
          class="ml-4"
          :hrefUrl="uploadUrl"
          v-btnAuth="['import-job-position']"
          :label="$t('label_Batch_Import')"
        >
        </mrc_ess_uploadBtn>
      </template>
      <template v-slot:search>
        <v-row
          class="d-flex justify-end"
          style="
            background: white;
            margin: 0;
            border-top-right-radius: 8px;
            border-top-left-radius: 8px;
            padding: 0 16px;
          "
        >
          <mrc_ess_advanceFilterAndSearchInput
            class="mt-4"
            v-model="systemSeniorQueryString"
            @success="getlist({ cpage: 1 })"
            :systemFieldMeta="systemFieldMeta"
          ></mrc_ess_advanceFilterAndSearchInput>
        </v-row>
      </template>
      <template v-slot:item.job_post_name="{ item }">
        <span :title="INT(item.job_post_name)">{{
          INT(item.job_post_name)
        }}</span
        ><br />
      </template>
      <!-- 所属部门及单位 -->
      <template v-slot:item.dept="{ item }">
        <div>{{ INT(item.dept_uuid) }}</div>
        <div
          class="dept_all"
          :title="INT(item.dept_all) | replaceclient_and_org"
        >
          {{ INT(item.dept_all) | replaceclient_and_org }}
        </div>
      </template>

      <!-- 状态 -->
      <template #item.is_used="{ item }">
        <mrc_ess_viewbtn
          :is_used="item.is_used_save_value"
          :label="item.is_used"
        ></mrc_ess_viewbtn>
      </template>

      <!-- 操作 -->
      <template #item.actions="{ item }">
        <menu-list :list="menulist" @handleClick="handleClick($event, item)">
          <template v-slot:showAction>
            <v-icon
              v-btnAuth="[
                'view-job-position',
                'edit-job-position',
                'delete-job-position',
              ]"
              >mdi-dots-vertical</v-icon
            >
          </template>
        </menu-list>
      </template>
    </mrc_ess_table>
    <template v-else>
      <router-view></router-view>
    </template>
  </div>
</template>

<script>
import { POST_URL } from "@/utils/constant/index.js";
import { getPostList, deletePost } from "@/service/api/postmanagement.js";
export default {
  components: {},
  props: {},
  computed: {
    headers() {
      return [
        {
          text: this.$t("label_Position_Title"),
          // text: this.$t('label_Post_and_Grade'),
          align: "start",
          sortable: false,
          value: "job_post_name",
        },
        {
          // text: this.$t("label_Department_and_unit"),
          text: this.$t("label_post_m_name"),
          align: "start",
          sortable: false,
          value: "dept",
        },
        {
          text: this.$t("label_Number_of_employees"),
          align: "start",
          sortable: false,
          value: "staffs_number",
        },
        {
          text: this.$t("label_Whether_to_enable"),
          align: "start",
          sortable: false,
          value: "is_used",
        },
        {
          text: "",
          value: "actions",
          sortable: false,
          align: "end",
        },
      ];
    },
    menulist() {
      return [
        {
          name: this.$t("label_View"),
          show: this.hasBtn("view-job-position"),
          type: "view",
        },
        {
          name: this.$t("label_Edit"),
          show: this.hasBtn("edit-job-position"),
          type: "edit",
        },
        {
          name: this.$t("label_delete"),
          show: this.hasBtn("delete-job-position"),
          type: "del",
        },
      ];
    },
  },
  filters: {
    replaceclient_and_org(val) {
      if (!val) return "";
      // return String(val).replaceAll('\\', '>').replaceAll('/', '>')
      return String(val).replace(/\//g, ">");
    },
  },
  data() {
    return {
      uploadUrl: "",
      systemFieldMeta: [],
      field_alias_name: null,
      table_alias_name: null,
      systemSeniorQueryString: [],
      loading: false,
      pageName: "new_positions",
      options: {
        pagesize: this.$store.state.pageSize, //条数
        cpage: this.$store.state.cpage, //页数
        totalcount: null, //总条数
        totalpage: null, //总页数
      },
      desserts: [],
      crsj: [],
    };
  },
  beforeCreate() {
    this.$store.commit("setCpage", 1);
  },
  async created() {
    this.uploadUrl = POST_URL;
    await this.getBtnPermissionList();
  },
  async mounted() {
    await this.getlist();
  },
  beforeDestroy() {},
  methods: {
    turnPage({ cpage, pagesize }) {
      this.options.cpage = cpage;
      this.options.pagesize = pagesize;
      this.getlist();
    },
    addnewpositions() {
      this.$store.commit("set_subPage_name", "");
      this.$store.commit("set_uuid", "");
      this.$store.commit("set_iconstatus", ""); //行内进图标显示
      this.$router.push({
        name: "new_positions",
      });
    },
    async getlist(obj) {
      //获取岗位列表
      this.loading = true;
      const org_level_uuid = this.$store.state.currentCompany;
      if (
        this.desserts &&
        this.desserts.length == 1 &&
        this.options.cpage != 1 &&
        this.$route.params.type == "del"
      )
        this.options.cpage--;
      if (obj) {
        const { cpage, pagesize } = obj;
        this.options = { ...this.options, ...obj };
      }
      const res = await getPostList({
        cpage: this.options.cpage,
        pagesize: this.options.pagesize,
        org_level_uuid,
        systemSeniorQueryString: this.systemSeniorQueryString,
        field_alias_name: this.field_alias_name,
        table_alias_name: this.table_alias_name,
      });
      if (res.code == 200) {
        this.options.totalcount = res.totalcount; //总条数
        this.options.totalpage = res.totalpage; //总页数
        this.desserts = res.data.map((item) => {
          // item.job_post_grades = (String(item.job_post_grades).indexOf(',') != -1) ? item.job_post_grades.split(',') : [item.job_post_grades];
          return item;
        });
        this.systemFieldMeta = res.systemFieldMeta;
        this.field_alias_name = res.field_alias_name;
        this.table_alias_name = res.table_alias_name;
      }
      this.loading = false;
    },
    godetail(item) {
      //行内进编辑详情页
      this.$store.commit("set_uuid", item.uuid);
      this.$store.commit("set_subPage_name", item.job_post_name);
      this.$store.commit("set_iconstatus", true); //行内进图标显示
      this.$router.push({
        name: "detail_positions",
        params: {
          uuid: item.uuid,
          iconstatus: true,
        },
      });
    },
    // 编辑
    editPrompt(item) {
      //详情页
      this.$store.commit("set_uuid", item.uuid);
      this.$store.commit("set_subPage_name", item.job_post_name);
      this.$store.commit("set_iconstatus", false); //行内进图标显示
      this.$router.push({
        name: "detail_positions",
        params: {
          uuid: item.uuid,
          iconstatus: false,
        },
      });
    },
    // 删除
    handleDel(item) {
      this.$myConfirm({
        content: this.$t("message_Confirm_the_deletion"),
      })
        .then(() => {
          deletePost({ uuid: item.uuid }).then((res) => {
            if (res.code == 200) {
              if (this.desserts.length == 1) this.options.cpage--;
              this.$Message({
                text: this.$t("message_The_deletion_was_successful"),
              });
              this.getlist();
            }
          });
        })
        .catch(() => {
          // console.log(22);
        });
    },
    handleClick({ item }, obj) {
      switch (item.type) {
        case "view":
          this.godetail(obj);
          break;
        case "edit":
          this.editPrompt(obj);
          break;
        case "del":
          this.handleDel(obj);
          break;
      }
    },
  },
  watch: {
    $route(val) {
      //监听路由变化
      // console.log(this.$route.path);
      if (this.$route.name == "jobs_manage") {
        // console.log('更新list');
        this.getlist();
      }
    },
  },
};
</script>

<style scoped>
.ft1 {
  font-size: 16px;
  text-align: left;
  display: inline-block;
  margin-top: 5px;
}
.chipbox {
  display: flex;
  padding-top: 15px;
  margin-bottom: 5px;
  max-width: 400px;
  height: 40px;
  line-height: 40px;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dept_all {
  color: rgba(0, 0, 0, 0.38);
  max-width: 400px;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
